import { useEffect, useState } from "react";
import { useCart } from "@/context/CartContext";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";
import { useLang } from "@/context/LangContext";
import { paymentStatus } from "@/lib/api";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState({ loading: true });
  const { tr } = useLang();
  const { clear } = useCart();
  useEffect(() => { if (sessionId) clear(); }, [sessionId, clear]);

  useEffect(() => {
    if (!sessionId) {
      setStatus({ loading: false, error: true, msg: tr("session_id mancante", "Missing session_id") });
      return;
    }
    let tries = 0;
    const poll = async () => {
      tries += 1;
      try {
        const data = await paymentStatus(sessionId);
        if (data.payment_status === "paid") {
          setStatus({ loading: false, paid: true, campaign_id: data.campaign_id });
          setTimeout(() => navigate(`/campaign/${data.campaign_id}`), 2200);
          return;
        }
      } catch {}
      if (tries < 20) setTimeout(poll, 1500);
      else setStatus({ loading: false, error: true, msg: tr("Timeout verifica pagamento", "Payment verification timed out") });
    };
    poll();
  }, [sessionId, navigate]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#E6EAEC] p-6">
      <div className="max-w-md w-full border border-[#e4e4e7] p-10 text-center">
        {status.loading && (
          <>
            <Loader2 className="w-10 h-10 mx-auto animate-spin text-[#E0262C] mb-4" />
            <h1 className="font-display text-2xl mb-2">{tr("Verifica pagamento", "Verifying payment")}</h1>
            <p className="text-sm text-[#71717a] font-mono">▸ {tr("Attesa conferma Stripe...", "Waiting for Stripe confirmation...")}</p>
          </>
        )}
        {status.paid && (
          <>
            <CheckCircle2 className="w-14 h-14 mx-auto text-[#10b981] mb-4" strokeWidth={2.5} />
            <h1 className="font-display text-3xl mb-2">{tr("Pagamento riuscito", "Payment successful")}</h1>
            <p className="text-sm text-[#52525b] mb-6">{tr("Il nostro team avvierà a breve la tua campagna: riceverai una notifica via email e nella tua area riservata. La fattura PDF ti è stata inviata via email. Reindirizzamento in corso...", "Our team will start your campaign shortly: you will be notified by email and in your reserved area. Your PDF invoice has been emailed to you. Redirecting...")}</p>
            <div className="font-mono text-[10px] text-[#71717a]">{tr("Conferma d'ordine inviata", "Order confirmation sent")}</div>
          </>
        )}
        {status.error && (
          <>
            <XCircle className="w-14 h-14 mx-auto text-[#ef4444] mb-4" />
            <h1 className="font-display text-2xl mb-2">{tr("Errore", "Error")}</h1>
            <p className="text-sm text-[#71717a] mb-6">{status.msg}</p>
            <Link to="/" className="aurora-text font-medium text-sm">{tr("Torna alla home →", "Back to home →")}</Link>
          </>
        )}
      </div>
    </div>
  );
}
